class Team {
	constructor(config) {
		this.config = Object.assign({
			scope: '.section-type-team',
			sliderSelector: '.team-slick-slider'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.find(this.config.sliderSelector).each((it, slider) => {
			let $slider = $(slider);
			$slider.slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				dots: false,
				arrows: true,
				prevArrow: $slider.closest(this.config.scope).find('.custom-slick-carousel-nav-prev'),
				nextArrow: $slider.closest(this.config.scope).find('.custom-slick-carousel-nav-next'),
				infinite: false,
				responsive: [
					{
						breakpoint: 1399,
						settings: {
							slidesToShow: 3
						}
					},
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1
						}
					},
				]
			});
		});
	}
}

export default new Team;